import { useSyncExternalStore } from 'react';
import { mayNavigate } from '../shared/navigation/navigation-guard';
const HISTORY_INDEX = 'gis3dNavigationIndex';
let acceptedIndex = 0;
let restoring = false;
function historyIndex(): number | undefined {
  const value = window.history.state?.[HISTORY_INDEX];
  return Number.isSafeInteger(value) ? value : undefined;
}
export function subscribeToPathname(listener: () => void) {
  acceptedIndex = historyIndex() ?? 0;
  window.history.replaceState({ ...window.history.state, [HISTORY_INDEX]: acceptedIndex }, '');
  const onPopState = () => {
    const target = historyIndex();
    if (restoring) {
      restoring = false;
      return;
    }
    if (!mayNavigate()) {
      if (target !== undefined && target !== acceptedIndex) {
        restoring = true;
        window.history.go(acceptedIndex - target);
      }
      return;
    }
    acceptedIndex = target ?? acceptedIndex;
    listener();
  };
  window.addEventListener('popstate', onPopState);
  window.addEventListener('gis3d:navigate', listener);
  return () => {
    window.removeEventListener('popstate', onPopState);
    window.removeEventListener('gis3d:navigate', listener);
  };
}
export function navigate(path: string, options?: { confirmed?: boolean }) {
  if (window.location.pathname === path) return;
  if (!options?.confirmed && !mayNavigate()) return;
  acceptedIndex++;
  window.history.pushState({ [HISTORY_INDEX]: acceptedIndex }, '', path);
  // This navigation already passed its guard; subscribers observe the new snapshot.
  window.dispatchEvent(new Event('gis3d:navigate'));
}
export function usePathname() {
  return useSyncExternalStore(
    subscribeToPathname,
    () => window.location.pathname,
    () => '/',
  );
}
